import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Avatar } from '@domain-group/fe-blueprint-ui/avatar';
import { useSendEvent, withEventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { CallButton } from '@domain-group/fe-co-allhomes-design-system';
import agentType from './props/agent-type';
import * as styles from './agent-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AgentCard = _ref => {
  var agent = _ref.agent,
    onPhoneClick = _ref.onPhoneClick;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var agentDetails = () => ___EmotionJSX("div", {
    css: styles.agentDetailsTextInnerWrapper
  }, ___EmotionJSX("span", {
    css: styles.name
  }, agent.name));
  var onProfileClick = () => {
    sendEvent('agent-enquiry-profile-click');
  };
  var agentAvatar = ___EmotionJSX(Avatar, {
    css: styles.avatar,
    imageUrl: agent.profilePhoto,
    size: "custom"
  });
  return ___EmotionJSX("div", {
    css: styles.agentCard
  }, ___EmotionJSX("div", null, isEmpty(agent.profileUrl) ? agentAvatar : ___EmotionJSX("a", {
    href: agent.profileUrl,
    onClick: onProfileClick,
    "aria-label": "agentPhoto"
  }, agentAvatar)), ___EmotionJSX("div", {
    css: styles.agentDetailsWrapper
  }, ___EmotionJSX("div", {
    css: styles.agentDetailsText
  }, isEmpty(agent.profileUrl) ? ___EmotionJSX("div", {
    css: styles.text
  }, agentDetails()) : ___EmotionJSX("a", {
    css: styles.text,
    href: agent.profileUrl,
    onClick: onProfileClick
  }, agentDetails())), ___EmotionJSX("div", null, agent.phone && ___EmotionJSX(CallButton, {
    css: styles.button,
    phone: agent.phone,
    appearance: "outline",
    onClick: onPhoneClick,
    showIcon: {
      beforeClick: false
    }
  }))));
};
AgentCard.propTypes = {
  agent: PropTypes.shape(agentType).isRequired,
  agency: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  onPhoneClick: PropTypes.func,
  index: PropTypes.number.isRequired // eslint-disable-line react/no-unused-prop-types
};
AgentCard.defaultProps = {
  onPhoneClick: () => {}
};
export { AgentCard as BaseAgentCard };
export default withEventBoundary(_ref2 => {
  var index = _ref2.index,
    agent = _ref2.agent,
    agency = _ref2.agency;
  return {
    data: {
      index,
      agentId: agent.id,
      agentName: agent.name,
      agencyId: agency.id,
      agencyName: agency.name
    }
  };
})(AgentCard);